// extracted by mini-css-extract-plugin
export var borderRadius = "_98-4";
export var large = "_98-3";
export var logoContainer = "_98-0";
export var nameLogo = "_98-2";
export var small = "_98-1";